var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider, useForm } from "react-hook-form";
import { useState } from "react";
import { handleError } from "./apiError";
const ApiFormWrapper = ({ defaultValues, mutation, resetOnSuccess = false, onSuccess, children, }) => {
    const methods = useForm({ defaultValues });
    const [isSuccess, setSuccess] = useState(false);
    const { reset, setError, handleSubmit: makeHandleSubmit, getValues, setValue, } = methods;
    const onSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield mutation(values).unwrap();
            if (resetOnSuccess) {
                reset();
            }
            if (result) {
                setSuccess(true);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
            }
        }
        catch (error) {
            handleError({ setError })(error);
        }
    });
    const handleSubmit = () => {
        void makeHandleSubmit(onSubmit)();
    };
    return (_jsx(FormProvider, Object.assign({}, methods, { children: children({
            getValues,
            setValue,
            isSuccess,
            submitForm: handleSubmit,
        }) })));
};
export default ApiFormWrapper;
